import {
    Button,
    FormControl,
    FormLabel, HStack,
    IconButton, Image,
    Input,
    InputGroup,
    InputRightElement,
    Switch,
    Text,
    useToast,
    VStack
} from "@chakra-ui/react";
import * as React from "react";
import {useEffect, useState} from "react";
import {useAppDispatch} from "../../hooks/use-store";
import {setIsSignup} from "../../store/reducers";
import {getUserProducerId, loginNew} from "../../data/api/Customer";
import {Resolver, useForm} from "react-hook-form";
import {LoginModel} from "../../data/model/Producer";
import {yupResolver} from "@hookform/resolvers/yup";
import {loginSchema} from "../../data/schema/signup";
import {LoginResponseNew} from "../../data/model/LoginResponse";
import {ViewIcon, ViewOffIcon} from "@chakra-ui/icons";
import {useNavigate} from "react-router-dom";
import {useMutation} from "@tanstack/react-query";
import {IS_SMARTVENUES} from "../../utils/Utils";
// import enotecaLogo from "../../../assets/images/enoteca_regionale_logo.png";
// import poweredSmartVenues from "../../../assets/images/powered_smart_venues.png";

export const LoginPage = () => {
    const dispatcher = useAppDispatch();
    const navigate = useNavigate();

    const methods = useForm<LoginModel>({
        mode: "all",
        resolver: yupResolver(loginSchema) as Resolver<LoginModel>
    });

    const [showPassword, setShowPassword] = useState(false);
    const toast = useToast();

    const {data, mutateAsync, isPending} = useMutation({mutationKey: ["producer_id"], mutationFn: getUserProducerId})

    const onSubmit = async (loginData: LoginModel) => {
        await loginNew({
            // email: loginData.username, TODO
            // password: loginData.password, TODO
            // userType: "admin" TODO
            // email: "angelo.fortuna@studium.unict.it",
            // password: "Test123!",
            // userType: "admin",
            email: loginData.username,
            password: loginData.password,
            // userType: "seller",
        }).then((data) => {
            const response = data?.data as LoginResponseNew;
            const {userType, producerId} = response?.data?.user || {};
            // console.log(`tokenNew => ${response.data?.accessToken}`);
            localStorage.setItem('tokenNew', response.data?.accessToken || "");
            localStorage.setItem('userType', userType || "seller");
            if (producerId) localStorage.setItem('producerId', producerId);

            // mutateAsync().then(value => {
            //     const id = value
            //     const id = value?.data || undefined;
            //     if (id) {
            //         localStorage.setItem('producerId', id);
            //     }
            // });

            if (response.data?.user?.producer?.id != null) {
                localStorage.setItem('producerId', response.data?.user?.producer?.id);
            }

            if (switchState) {
                localStorage.setItem('username', loginData?.username ?? "");
                localStorage.setItem('password', loginData?.password ?? "");
            }

            window.location.replace("/products");
        }).catch(reason => {
            console.error(reason.message);
            toast({
                title: "Si è verificato un errore",
                description: "Il nome utente o password inserita non sono corretti"
            });
            setError("username", {
                message: "Il nome utente o la password non sono corretti"
            });
            setError("password", {});
        });

        // await login(loginData).then((data) => {
        //     const loginResponse = data?.data as LoginResponse;
        //     localStorage.setItem('token', loginResponse.data.token);
        //     mutateAsync().then(value => {
        //         const id = value?.data || undefined;
        //         if (id) {
        //             localStorage.setItem('producerId', id);
        //         }
        //     });
        //
        //     if (switchState) {
        //         localStorage.setItem('username', loginData?.username ?? "");
        //         localStorage.setItem('password', loginData?.password ?? "");
        //     }
        //     navigate('/');
        // }).catch(reason => {
        //     console.error(reason.message);
        //     toast({
        //         title: "Si è verificato un errore",
        //         description: "Il nome utente o password inserita non sono corretti"
        //     });
        //     setError("username", {
        //         message: "Il nome utente o la password non sono corretti"
        //     });
        //     setError("password", {});
        // });
    }

    const {
        register,
        handleSubmit,
        setError,
        setValue,
        trigger,
        formState: {
            errors,
            isSubmitting,
            isValid
        }
    } = methods;

    const initialSwitchState = !!localStorage.getItem("username") && !!localStorage.getItem("password");
    const [switchState, setSwitchState] = useState(initialSwitchState);

    const handleSwitchChange = () => {
        setSwitchState(!switchState);
    };

    useEffect(() => {
        const username = localStorage.getItem("username");
        const password = localStorage.getItem("password");

        if (!!username && !!password) {
            setValue("username", username);
            setValue("password", password);

            trigger("username");
            trigger("password");
        }
    }, []);

    return <VStack px={"20%"}>
        {!IS_SMARTVENUES && <HStack w={'80%'} gap={"16px"}>
            <Image src={"/images/enoteca_regionale_logo.png"} width={"60%"}/>
            <Image src={"/images/powered_smart_venues.png"} width={"30%"}/>
        </HStack>}
        <Text variant={"heading"} mt={IS_SMARTVENUES ? 0 : "48px"} fontSize={"3vh"} fontStyle={"normal"}
              color={"primary.400"}>Accedi</Text>

        <Text
            color={"primary.400"}
            alignSelf={"start"}
            fontSize={16}>Username</Text>

        <Input
            colorScheme={"primary"}
            variant='filled'
            isInvalid={!!errors.username}
            disabled={isSubmitting}
            errorBorderColor={"error.700"}
            focusBorderColor={!!errors.username ? "error.700" : "primary.400"}
            _placeholder={{
                fontSize: 14
            }}
            {...register('username')}
            placeholder="Inserisci l'username"/>

        <Text fontSize={14}
              alignSelf={"start"}
              mt={"8px"}
              textColor={"error.700"}>
            {errors.username && errors.username.message}
        </Text>

        <Text
            color={"primary.400"}
            alignSelf={"start"}
            mt={"24px"}
            fontSize={16}>Password</Text>

        <InputGroup>
            <Input
                variant='filled'
                colorScheme={"primary"}
                disabled={isSubmitting}
                errorBorderColor={"error.700"}
                type={showPassword ? 'text' : 'password'}
                isInvalid={!!errors.password}
                focusBorderColor={!!errors.password ? "error.700" : "primary.400"}
                {...register('password')}
                placeholder='Inserisci la password'
                _placeholder={{
                    fontSize: 14
                }}
            />

            <InputRightElement width="4.5rem">
                <IconButton
                    h="1.75rem"
                    size="sm"
                    onClick={() => {
                        setShowPassword(!showPassword)
                    }}
                    icon={showPassword ? <ViewOffIcon/> : <ViewIcon/>}
                    aria-label={showPassword ? 'Nascondi password' : 'Mostra password'}
                />
            </InputRightElement>
        </InputGroup>

        <Text
            fontSize={14}
            alignSelf={"start"}
            mt={"8px"}
            textColor={"error.700"}>
            {errors.password && errors.password.message}
        </Text>

        <FormControl display='flex' alignItems='center' mt={"24px"}>
            <Switch id='remember-alerts' onChange={handleSwitchChange} size={"lg"} colorScheme={"primary"}
                    defaultChecked={initialSwitchState}/>
            <FormLabel htmlFor='remember-alerts' color={"primary.400"} mb='0' ms={"16px"}>
                Ricordami
            </FormLabel>
        </FormControl>

        <Button mt={"48px"} isDisabled={!isValid} isLoading={isSubmitting} variant={"primary"}
                onClick={handleSubmit(onSubmit)}>Entra</Button>

        <Button
            variant={"tertiary"}
            mt={"8px"}
            onClick={() => {
                dispatcher(setIsSignup(true));
            }}
        >Registrati</Button>
    </VStack>
}
